const lvLV = {
  components: {
    MuiBreadcrumbs: {
      defaultProps: {
        expandText: 'Rādīt visu ceļu',
      },
    },
    MuiTablePagination: {
      defaultProps: {
        getItemAriaLabel: (type) => {
          if (type === 'first') {
            return 'Doties uz pirmo lapu';
          }

          if (type === 'last') {
            return 'Doties uz pēdējo lapu';
          }

          if (type === 'next') {
            return 'Doties uz nākamo lapu';
          } // if (type === 'previous') {

          return 'Doties uz iepriekšējo lapu';
        },
        labelRowsPerPage: 'Rindas lapā:',
        labelDisplayedRows: ({ from, to, count }) => `${from}–${to} no ${count !== -1 ? count : `vairāk nekā ${to}`}`,
      },
    },
    MuiRating: {
      defaultProps: {
        getLabelText: (value) => {
          let pluralForm = 'Zvaigznes';
          const lastDigit = value % 10;

          if (lastDigit > 1 && lastDigit < 5) {
            pluralForm = 'Zvaigznes';
          } else if (lastDigit === 1) {
            pluralForm = 'Zvaigzne';
          }

          return `${value} ${pluralForm}`;
        },
        emptyLabelText: 'Nav vērtējuma',
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        clearText: 'Notīrīt',
        closeText: 'Aizvērt',
        loadingText: 'Notiek ielāde…',
        noOptionsText: 'Opcijas nav pieejamas',
        openText: 'Atvērt',
      },
    },
    MuiAlert: {
      defaultProps: {
        closeText: 'Aizvērt',
      },
    },
    MuiPagination: {
      defaultProps: {
        'aria-label': 'Navigācija lapā',
        getItemAriaLabel: (type, page, selected) => {
          if (type === 'page') {
            if (selected) {
              return `${page} lapu`;
            }

            return `Doties uz ${page} lapu`;
          }

          if (type === 'first') {
            return 'Doties uz pirmo lapu';
          }

          if (type === 'last') {
            return 'Doties uz pēdējo lapu';
          }

          if (type === 'next') {
            return 'Doties uz nākamo lapu';
          }

          return 'Doties uz iepriekšējo lapu';
        },
      },
    },
  },
};

export default lvLV;
